import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { change, Field, reduxForm } from 'redux-form'
import { Col, Row } from 'react-bootstrap'
import { Dropzone } from 'Components/Form/Dropzone'
import { LinkExternal } from 'Components/LinkExternal'
import { SelectDashboard } from 'Components/Form/SelectDashboard'

import { CONFIG } from 'Config/config'
import { ACTION_EDIT } from 'constants.js'
import { getCampaignLink } from 'Utils/Link'

import { localStore } from 'Module/Browser/LocalStorage'

import { required } from 'Utils/Validators/formValidation'
import { optionSortFunc } from 'Utils/Filters'

const noCampaignSelectedLinkText =
  'Please select a campaign to download the CSV template'
const campaignSelectedLinkText = 'Download the csv template'
const cannotUploadTextIntro =
  'You cannot upload a conversion report if the campaign has no setup metrics. Please '
const cannotUploadTextLink = 'edit the campaign '
const cannotUploadTextEnd = 'to add the metric you want to track.'

class AddConversionReportFormUnstyled extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      campaignId: null,
      templateLink: null,
    }

    this.getCampaignsOptions = this.getCampaignsOptions.bind(this)
    this.onCampaignChange = this.onCampaignChange.bind(this)
  }

  componentDidUpdate() {
    const {
      initiallySelectedCampaign,
      campaigns,
      changeFieldValue,
    } = this.props
    const { campaignId } = this.state

    let selectedId = null

    if (!campaignId) {
      const initiallySelected =
        initiallySelectedCampaign !== null
          ? campaigns.find(_ => _.id === initiallySelectedCampaign)
          : campaigns[0]

      selectedId = initiallySelected ? initiallySelected.id : null
    }

    if (selectedId !== null) {
      changeFieldValue('campaign_id', selectedId)

      this.setState({ campaignId: selectedId })
    }

    this.props.setSelectedCampaignId(campaignId)
  }

  render() {
    if (!this.props.campaigns || !this.props.campaigns.length) {
      return 'Loading'
    }
    const { className, handleSubmit } = this.props
    const campaign = this.props.campaigns.find(
      c => c.id === this.state.campaignId,
    )

    return (
      <form className={className} onSubmit={handleSubmit}>
        <Row>
          <Col xs={6}>
            <Field
              component={SelectDashboard}
              name="campaign_id"
              onChange={this.onCampaignChange}
              props={{
                label: 'Campaign',
                options: this.getCampaignsOptions(),
                id: 'report_campaign_select',
              }}
              validate={[required]}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>{this.renderTemplateDownloadLink(campaign)}</Col>
        </Row>
        <Row>
          <Col xs={12}>{this.renderUploadField(campaign)}</Col>
        </Row>
      </form>
    )
  }

  renderTemplateDownloadLink(campaign) {
    const { campaignId } = this.state
    const apiKey = localStore.getData(CONFIG.STORE.API_KEY)
    if (campaign && !campaign.metrics.nodes.length) {
      return null
    }

    if (campaignId) {
      return (
        <LinkExternal
          href={`${
            CONFIG.API_BASE_URL
          }/campaigns/${campaignId}/report-template?apiKey=${apiKey}`}
          target="_blank"
        >
          {campaignSelectedLinkText}
        </LinkExternal>
      )
    } else {
      return noCampaignSelectedLinkText
    }
  }

  renderUploadField(campaign) {
    if (campaign && !campaign.metrics.nodes.length) {
      const url = getCampaignLink(campaign, ACTION_EDIT)

      return [
        cannotUploadTextIntro,
        <LinkExternal key="edit-campaign" href={url}>
          {cannotUploadTextLink}
        </LinkExternal>,
        cannotUploadTextEnd,
      ]
    }
    return (
      <Field
        className="upload-report"
        component={Dropzone}
        name="report"
        onChange={this.uploadAmbassadorDocument}
        props={{
          accept: 'text/csv',
          mainLabel: 'Report File',
          progress: this.props.progress,
        }}
        validate={[required]}
      />
    )
  }

  getCampaignsOptions() {
    const { campaigns } = this.props
    return campaigns
      .map(campaign => ({
        label: campaign.name,
        value: campaign.id,
      }))
      .sort(optionSortFunc)
  }

  onCampaignChange(e, campaignId) {
    this.setState({
      initiallySelectedCampaign: null,
      campaignId,
    })
  }
}

AddConversionReportFormUnstyled.propTypes = {
  campaigns: PropTypes.array.isRequired,
  changeFieldValue: PropTypes.func.isRequired,
  form: PropTypes.string.isRequired,
  initiallySelectedCampaign: PropTypes.string,
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  changeFieldValue: (field, value) =>
    dispatch(change(ownProps.form, field, value)),
})

AddConversionReportFormUnstyled = connect(
  null,
  mapDispatchToProps,
)(AddConversionReportFormUnstyled)

AddConversionReportFormUnstyled = reduxForm({
  enableReinitialize: true,
})(AddConversionReportFormUnstyled)

export default AddConversionReportFormUnstyled



// WEBPACK FOOTER //
// ./src/Containers/Form/Campaigns/AddConversionReport/unstyled.js